<template>
  <div class="pengumuman-container">
      <Forbidden
      v-if="getUserRole[getUserRole.length - 1].role_id != userRole.STUDENT"
      routerPath="incorrectRole"
    />
    <Forbidden v-else-if="!getReregistrationPeriodOpened" routerPath="notInPeriod" />
    <Forbidden
      v-else-if="!getHasFilledSurveyForm && getStudentTermStatus != termStatus.TERM_BREAK"
      routerPath="notFillSurvey"
    />
    <section v-else class="vector-background col center">
        <b-form id="decision-form">
          <h2 class="header-title">Form Daftar Ulang</h2>
          <b-row align-v="start">
            <b-col sm="12">
              <b-form-group
                id="decision-group"
                class="mt-4"
                label="Apakah kakak ingin lanjut belajar di program Qaaf semester depan?"
                label-for="decision"
              >
                <b-form-radio-group
                  id="decision"
                  v-model="form.decisionStatus"
                  name="decision"
                  button-variant="primary"
                  :options="form.answerOptions"
                  value-field="item"
                  text-field="name"
                  aria-describedby="decision-live-feedback"
                ></b-form-radio-group>
                <b-form-invalid-feedback
                  id="decision-live-feedback"
                  class="error_decision"
                >Mohon isi form keputusan</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        <b-button
          v-if="form.decisionStatus != 0"
          id="submit"
          type="submit"
          size="sm"
          for="decision-form"
          ref="btn-submit"
          variant="none"
          class="primary mt-4"
          @click="$bvModal.show('confirm-modal')"
        >Kirim
        </b-button>

        <b-modal id="confirm-modal" hide-footer>
          <template v-slot:modal-title>
            Konfirmasi
          </template>
          <div class="d-block text-center">
            <h3>Apakah kakak yakin dengan keputusan kakak?</h3>
            <div 
              class="rejected" 
              v-if="getStudentTermStatus == termStatus.TERM_BREAK && 
              form.decisionStatus == 2">
                Setelah kakak memilih cuti, kakak akan dianggap keluar.
            </div>
          </div>
          <b-row class="ml-3 mt-3">
            <b-button class="col-5 " variant="none" size="sm" @click="$bvModal.hide('confirm-modal')">Belum Yakin</b-button>
            <b-button class="col-5 ml-3 primary" size="sm" @click="onSubmit">Yakin</b-button>
          </b-row>
        </b-modal>
    </section>
  </div>
</template>

<script>
import Forbidden from "@/views/Forbidden";
import { mapGetters } from "vuex";
import User from "@/services/User";
import store from "@/store";
import { UserRole, TermStatus } from "@/services/StatusCode";

export default {
  name: "DecisionForm",
  data() {
    return {
      form : {
        decisionStatus: 0,
        answerOptions: {
          1 : "Keluar dari program",
          2 : "Cuti selama satu semester",
          3 : "Lanjut program"
        }
      },
      userRole: UserRole,
      termStatus: TermStatus
    };
  },
  components: {
    Forbidden
  },
  methods : {
    onSubmit() {      
      this.postForm();
    },
    async postForm() {
      User.uploadDecisionForm(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName,
        this.form)
        .then(async () => {
          await store.dispatch("RESETSTATE");
          if (this.form.decisionStatus == 1) {
            location.href = location.origin + "/download-report";
          } else {
            location.href = location.origin + "/";
          }
        });
    }
  },
  async created() {    
    if (this.getTermName != "") {
      await User.getHasFilledSurvey(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName
      );
    }  
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUserId: "getUserId",
      getUserRole: "getUserRole",
      getTermName: "getTermName",
      getRegistrationData: "getRegistrationData",
      getFullname: "getFullname",
      getStudentTermStatus: "getStudentTermStatus",
      getReregistrationPeriodOpened: "getReregistrationPeriodOpened",
      getEndedTermId: "getEndedTermId",
      getHasFilledSurveyForm: "getHasFilledSurveyForm"
    }),
  }
};
</script>


<style lang="scss" scoped>
@import "@/styles/form.scss";

@media only screen and (min-width: 768px) {
  h1.header-title {
    font-size: $h1 !important;
  }

  h2.header-title {
    font-size: $h2 !important;
  }

  h3.header-title {
    font-size: $h3 !important;
  }

  .hero-message {
    margin-bottom: 5%;
    max-width: 50%;
  }
  .message {
    max-width: 100% !important;
    font-size: 16px !important;
  }
}

.pengumuman-container {
  min-height: inherit;
}

.rejected {
  color: red;
}

.hero-message {
  max-width: 75%;
  margin-bottom: $gap-m-2;
}

.message {
  margin-top: $gap-sm-1;
  text-align: center;
  max-width: 80%;
  font-size: 12px;
}

.message-container {
  min-width: 20%;
  max-height: 40%;
  margin-bottom: $gap-m-2;
}

.header-title {
  margin-bottom: $gap-m-1;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.nominal-container {
  text-align: center;
  .nominal {
    font-size: 24px;
  }
}
.pembayaran-container {
  .salin-jumlah {
    color: $primary;
  }
}

.success-payment-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rekening-container {
  display: flex;
  align-items: center;
  margin: $gap-sm-2 0;

  .rekening {
    padding: $gap-sm-1 $gap-sm-2;
    background: $white;
    margin-right: $gap-sm-2;
  }
}

#submit {
  display: flex;
  align-items: center;

  .material-icons {
    color: white;
    margin-left: $gap-sm-1;
  }
}

.upload-container {
  margin-top: $gap-sm-2;
}

.red {
  color: #eb4d55;
}

.black {
  color: #000000;
}

.svg-4 {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-width: 40%;
  max-height: 20%;
}

.svg-5 {
  position: absolute;
  z-index: -2;
  bottom: 0;
  left: 0;
  max-width: 40%;
  max-height: 25%;
}

.svg-6 {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
  max-width: 40%;
  max-height: 50%;
}

.svg-7 {
  position: absolute;
  z-index: -2;
  bottom: 0;
  right: 0;
  max-width: 30%;
  max-height: 50%;
}
</style>

